export default __webpack_public_path__ + "static/media/bg_gray_logo.c6d0bdcc.png";